import React from "react";
import { Platform, View } from "react-native";
import { Text } from "@clearabee/ui-library-native";
import { Spinner } from "components/Core/Spinner/Spinner";
import { styles, ids } from "./ProductDetailsSubmit.styles";
import { Button } from "components/Core/Button/Button";
import { useTranslation } from "react-i18next";
import { getTestId } from "lib/getTestId";

export interface ProductDetailsSubmitProps {
  isLoading?: boolean;
  disabled?: boolean;
  paymentRequired: boolean;
  isOverlayShowing?: boolean;
  onSubmit: () => void;
  children?: React.ReactNode;
}

export const ProductDetailsSubmit = ({
  isLoading,
  disabled,
  onSubmit,
  paymentRequired,
  children,
}: ProductDetailsSubmitProps): React.ReactElement => {
  const [translate] = useTranslation();

  return (
    <View style={styles.addToBasket} dataSet={{ media: ids.addToBasket }}>
      {isLoading && (
        <Spinner
          size="large"
          color="accent"
          style={styles.loader}
          dataSet={{ media: ids.loader }}
        />
      )}

      <Button
        type="submit"
        onClick={onSubmit}
        disabled={disabled}
        styles={styles.submit}
        color="accent"
        {...getTestId("productDetailsSubmitButton")}
      >
        <View style={styles.submit}>
          {!paymentRequired ? (
            <Text styles={{ fontFamily: "ProximaSemiBold" }}>
              {translate("hwa.screens.checkout.confirmBooking")}
            </Text>
          ) : (
            <>
              <Text>{translate("common.addToBasket")}</Text>
              {!!children && (
                <>
                  <Text>:</Text>
                  <Text styles={{ fontFamily: "ProximaBold" }}>
                    {" "}
                    {children}
                  </Text>
                </>
              )}
            </>
          )}
        </View>
      </Button>
    </View>
  );
};
